// extracted by mini-css-extract-plugin
export default {"toggle":"Menu_toggle__nZqIb","dropdownMenu":"Menu_dropdownMenu__jAXaF","dropdownLink":"Menu_dropdownLink__9kI+a"};